// ********* CardCAgendamentos - agendamentos.jsx ********
// autor: W de Paula / MVinfo
// data: 06/6/24 | 17h50
// data: 24/9/24 | 20h39 | cópia do modelo agendexCliente, mas, precisa de correções, como por exemplo de "Nome Empresa" para "Nome Cliente", etc
// data: 17/10/25 | 19h16 | acrescentado obs e eliminado linhas comentadas desnecessárias
// **************************************************




import './p_agendamentos.css';

function CardCAgendamentos({agendamento, showOpcoes, showExcluir, showAvaliar, showMotivo, showMudarStatus, handleAvaliar, handleExcluir, handleMotivo, handleMudarStatus, tipoAtendimento, handleOpcoes }) {
   
    const formatCurrency = (value) => {
        return value !== undefined && value !== null ? 
            value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) : 
            'N/A';
    }

    const formatData = (data) => {
        return data ? data.split(' ')[0] : 'Data não informada';
    };

    const formatHora = (hora) => {
        return hora ? `${hora}h` : 'Hora não informada';
    };




    return (
        <tr key={agendamento.agendamento_id}>
            <td data-label="Id">{agendamento.agendamento_id}</td>
            <td data-label="Descrição">{agendamento.agendamento_descricao || 'Descrição não informada'}</td>
            <td data-label="Nome Cliente">{agendamento.agendamento_nome || 'Nome não informado'}</td>
            <td data-label="Fone Cliente">
                { agendamento.agendamento_fone ? agendamento.agendamento_fone : 'N/A' }
            </td>
            <td data-label="Data:">{formatData(agendamento.agendamento_data)}</td>
            <td data-label="Hora:">{formatHora(agendamento.agendamento_hora)}</td>
            <td data-label="Valor:">
                {agendamento.agendamento_vr === undefined ? 'N/A' : formatCurrency(agendamento.agendamento_vr)}
            </td>
            {/* {(tipoAtendimento === 1 ) && ( */}
            <td data-label="Desconto:">
                {agendamento.agendamento_desc === undefined ? 'N/A' : formatCurrency(agendamento.agendamento_desc)}
            </td>
            {/* )} */}
            {/* {(tipoAtendimento === 1 ) && ( */}
            <td data-label="Vr Total:">
                {agendamento.agendamento_vrtot === undefined ? 'N/A' : formatCurrency(agendamento.agendamento_vrtot)}
            </td>
            {/* )} */}
            {/* )} */}
            {/* {console.log(agendamento)} */}
            {(tipoAtendimento === 1 ) && (
                <td data-label="Colaborador:">
                   {agendamento.agendamento_nome_colaborador}
                </td>
            )}
            <td data-label="Obs">{agendamento.agendamento_obs || 'Obs indisp'}</td>
            <td data-label="Status:" className="text-right">{agendamento.agendamento_status || 'Status não informado'}</td>
            { (showAvaliar || showMotivo || showExcluir || showMudarStatus || showOpcoes) && (
                <td data-label="Ações:">
                    {showAvaliar && (
                        <button className="btn btn-info ml-2" onClick={() => handleAvaliar(agendamento)}>
                            <i className="bi bi-star-half"></i> Avaliar
                        </button>
                    )}
                    {showMotivo && (
                        <button className="btn btn-warning ml-2" onClick={() => handleMotivo(agendamento)}>
                            <i className="bi bi-x-circle"></i> Motivo
                        </button>
                    )}
                    {showExcluir && (
                        <button className="btn btn-danger ml-2" onClick={() => handleExcluir(agendamento)}>
                            <i className="bi bi-trash-fill"></i> Excluir
                        </button>
                    )}
                    {showMudarStatus && (
                        <button className="btn btn-warning ml-2" onClick={() => handleMudarStatus(agendamento)}>
                            <i className="bi bi bi-gear-fill"></i> Mudar Status
                        </button>
                    )}
                    {showOpcoes && (
                        <button className="btn btn-warning ml-2" onClick={() => handleOpcoes(agendamento)}>
                            <i className="bi bi bi-gear-fill"></i> Opções
                        </button>
                    )}
                </td>
            )}
        </tr>
    );
    
}

export default CardCAgendamentos;